import { Tabs } from "tailwindcss-stimulus-components"

// Library Tabs + opt-in URL query-param persistence.
//
// Add `data-tabs-param="tab"` to the controller element and the active tab
// index is mirrored to the URL query string (e.g. ?tab=2) via replaceState,
// so the selected tab survives a reload and is shareable/bookmarkable. On
// load, ?tab=N selects that tab. Without `data-tabs-param` it behaves exactly
// like the upstream Tabs controller (no URL changes), so tabs elsewhere in the
// app are unaffected.
export default class extends Tabs {
  initialize() {
    if (super.initialize) super.initialize()
    if (!this.data.has("param")) return
    const n = this._tabFromUrl()
    if (n !== null && n < this.tabTargets.length) this.indexValue = n
  }

  indexValueChanged() {
    super.indexValueChanged()
    if (this.data.has("param")) this._syncUrl()
  }

  _tabFromUrl() {
    const raw = new URLSearchParams(window.location.search).get(this.data.get("param"))
    if (raw === null) return null
    const n = parseInt(raw, 10)
    return Number.isInteger(n) && n >= 0 ? n : null
  }

  _syncUrl() {
    const params = new URLSearchParams(window.location.search)
    params.set(this.data.get("param"), this.indexValue)
    history.replaceState(history.state, "", `${window.location.pathname}?${params}${window.location.hash}`)
  }
}
